<template>
  <section class="featured-features">
    <div class="featured-features--header">
      <div>
        <div class="featured-features--eyebrow">
          <span class="featured-features--eyebrow-line"></span>
          <span>Fitur Unggulan</span>
        </div>
        <h2>Perluas Peluang Kerja Agen Dalam Satu Ekosistem.</h2>
      </div>
    </div>

    <div class="featured-features--grid">
      <router-link
        v-for="feature in features"
        :key="feature.title"
        class="featured-features--card"
        :to="feature.to"
      >
        <div class="featured-features--top-bar"></div>

        <div class="featured-features--icon">
          <img :src="feature.icon" :alt="feature.title" />
        </div>

        <div class="featured-features--body">
          <div class="featured-features--title-row">
            <h3>{{ feature.title }}</h3>
            <span v-if="feature.badge" class="featured-features--badge">{{ feature.badge }}</span>
          </div>
          <p>{{ feature.description }}</p>
        </div>

        <div class="featured-features--footer">
          <v-icon class="featured-features--arrow">mdi-arrow-right</v-icon>
        </div>
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: 'featured-features-section',
  computed: {
    features() {
      return [
        {
          title: 'Agen Pilihan',
          description: 'Tingkatkan visibilitas profil dan listing pada area pilihan Anda.',
          to: '/layanan-agen/agen-properti-pilihan/cara-kerja',
          icon: require('@/assets/icons/featured-features/agen-pilihan.svg'),
        },
        {
          title: 'Agen Naik Kelas',
          description:
            'Bangun kredibilitas lewat badge verifikasi yang lebih mudah dikenali buyer.',
          to: '/layanan-agen/agen-naik-kelas',
          icon: require('@/assets/icons/featured-features/agen-naik-kelas.svg'),
          badge: 'BARU',
        },
        {
          title: 'Listing Rekomendasi',
          description: 'Tingkatkan posisi listing agar lebih mudah ditemukan calon pembeli.',
          to: '/layanan-agen/rekomendasi-listing/cara-kerja',
          icon: require('@/assets/icons/featured-features/listing-rekomendasi.svg'),
          badge: 'BARU',
        },
        {
          title: 'Owner Connect',
          description: 'Dapatkan lebih banyak listing langsung dari pemilik properti.',
          to: '/layanan-agen/owner-connect/cara-kerja',
          icon: require('@/assets/icons/featured-features/owner-connect.svg'),
        },
        {
          title: 'Project Connect',
          description:
            'Temukan proyek properti terbaru untuk Anda pasarkan, langsung dari developer',
          to: '/layanan-agen/project-connect/cara-kerja',
          icon: require('@/assets/icons/featured-features/project-connect.svg'),
          badge: 'BARU',
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/utils/variables';

.featured-features {
  padding: 64px 0 42px;
}

.featured-features--header {
  display: grid;
  grid-template-columns: minmax(0, 0.72fr) minmax(220px, 0.28fr);
  gap: 32px;
  align-items: end;
  margin-bottom: 30px;

  h2 {
    margin: 0;
    color: #17191d;
    font-family: Poppins-Bold, sans-serif;
    max-width: 620px;
    font-size: 31px;
    line-height: 1.22;
    letter-spacing: -0.02em;
  }

  p {
    margin: 0;
    max-width: 360px;
    color: #6b7480;
    font-family: Poppins, sans-serif;
    font-size: 14px;
    line-height: 1.75;
    align-self: end;
  }
}

.featured-features--eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;

  span {
    font-family: Poppins-Bold, sans-serif;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: $color-beliruma-1;
  }
}

.featured-features--eyebrow-line {
  display: inline-block;
  width: 28px;
  height: 2px;
  border-radius: 2px;
  background: $color-beliruma-1;
}

.featured-features--grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}

.featured-features--card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 230px;
  padding: 20px 18px 18px;
  border: 1px solid #e3e7ee;
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.86)), #ffffff;
  color: #17191d;
  text-decoration: none;
  overflow: hidden;
  transition: border-color 0.2s ease, transform 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 18px;
    background: radial-gradient(
      circle at 24px 24px,
      rgba($color-beliruma-1, 0.1),
      transparent 54px
    );
    opacity: 0;
    transition: opacity 0.2s ease;
    pointer-events: none;
  }

  &:hover {
    border-color: rgba(215, 25, 32, 0.22);
    color: #17191d;
    text-decoration: none;
    transform: translateY(-3px);

    &::after {
      opacity: 1;
    }

    .featured-features--top-bar {
      transform: scaleX(1);
    }

    .featured-features--icon {
      background: rgba($color-beliruma-1, 0.08);
      border-color: rgba($color-beliruma-1, 0.18);
    }

    .featured-features--arrow {
      color: $color-beliruma-1 !important;
      transform: translateX(2px);
    }
  }

  &:first-child {
    grid-row: auto;
    min-height: 230px;
    padding: 20px 18px 18px;
    background: linear-gradient(180deg, rgba(215, 25, 32, 0.08), rgba(255, 255, 255, 0.96)), #ffffff;

    .featured-features--icon {
      width: 54px;
      height: 54px;
      border-radius: 16px;

      img {
        width: 28px;
        height: 28px;
      }
    }

    .featured-features--title-row h3 {
      font-size: 15px;
      line-height: 1.28;
    }

    .featured-features--body p {
      max-width: none;
      font-size: 12.5px;
    }

    .featured-features--footer {
      margin-top: auto;
    }
  }
}

.featured-features--top-bar {
  position: absolute;
  top: 0;
  left: 20px;
  right: 20px;
  height: 2.5px;
  border-radius: 0 0 8px 8px;
  background: $color-beliruma-1;
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 0.25s ease;
}

.featured-features--icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 1px solid #e5e9f0;
  border-radius: 12px;
  background: #f7f8fa;
  margin-bottom: 16px;
  flex-shrink: 0;
  transition: background 0.2s ease, border-color 0.2s ease;

  img {
    width: 22px;
    height: 22px;
    object-fit: contain;
  }
}

.featured-features--body {
  flex: 1;
}

.featured-features--title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  h3 {
    margin: 0;
    color: #17191d;
    font-family: Poppins-Bold, sans-serif;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: -0.01em;
  }
}

.featured-features--badge {
  padding: 2px 7px;
  border-radius: 999px;
  background: rgba($color-beliruma-1, 0.08);
  color: $color-beliruma-1;
  font-family: Poppins-Bold, sans-serif;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  white-space: nowrap;
}

.featured-features--body p {
  margin: 0;
  color: #6b7480;
  font-family: Poppins, sans-serif;
  font-size: 12.5px;
  line-height: 1.65;
}

.featured-features--footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 18px;
}

.featured-features--arrow {
  color: #727b89 !important;
  font-size: 18px !important;
  transition: color 0.2s ease, transform 0.2s ease;
}

@media (max-width: 1024px) {
  .featured-features--grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .featured-features--card:first-child {
    grid-row: auto;
    min-height: 230px;
  }

  .featured-features--header {
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .featured-features {
    padding: 40px 0 0;
  }

  .featured-features--header {
    grid-template-columns: 1fr;
    gap: 12px;

    h2 {
      font-size: 22px;
    }
  }

  .featured-features--grid {
    grid-template-columns: 1fr;
  }

  .featured-features--card {
    min-height: unset;
  }

  .featured-features--card:first-child {
    min-height: unset;
    padding: 22px 20px 20px;

    .featured-features--title-row h3 {
      font-size: 16px;
    }

    .featured-features--body p {
      font-size: 12.5px;
    }
  }
}
</style>
